import { BlueprintInstanceType, Countertop, Island } from '@rta/rta-blueprint-library';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const countertopPropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Countertop Properties',
		onClick: ({ refMap, controller }): void => {
			let refItem: Countertop | Island = refMap[refMap.type] as Countertop;
			// let refItem: Countertop | Island = appState.ui.pointer.context.ref as Countertop;

			// if only 1 island, then return island id
			if (refItem.instanceOf === BlueprintInstanceType.Countertop && refItem.islandIds.length === 1) {
				refItem = refItem.refMap.kitchen.getReferenceMap(refItem.islandIds[0]).island
			}

			controller.publishShowProperties('countertop', refItem.id);
		}
	}
};
